import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { allColors } from "../../constants";

function TextInput({
  InputStartIcon,
  InputEndIcon,
  fullWidth,
  readonly,
  marginTop,
  placeholder,
  inputPadding,
  bgColor,
  value,
  onChange,
  inputLabel,
  isMultiline,
  minRows,
  name,
  type,
  inputError,
  helperText
}) {
  return (
    <TextField
      fullWidth={fullWidth}
      name={name}
      onChange={(e) => onChange && onChange(e)}
      value={value}
      id="outlined-basic"
      type={type || "text"}
      multiline={isMultiline}
      rows={minRows}
      error={inputError}
      helperText={helperText}
      sx={{
        marginTop: marginTop,
        "&.MuiFormControl-root .MuiFormLabel-root": {
          marginLeft: "15px",
          color: allColors.darkGray,
          fontSize: "12px",
        },
        "& .MuiInputBase-root": {
          borderRadius: "15px",
          fontSize: "12px",
          background: bgColor ? bgColor : "transparent",
        },
        "& .MuiInputBase-root input": {
          padding: inputPadding ? inputPadding : "13px 16px",
        },
        "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
          borderColor: `${allColors.silverSand} !important`,
        },
      }}
      placeholder={placeholder}
      label={inputLabel}
      variant="outlined"
      InputProps={{
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment position="end" sx={{ cursor: "pointer" }}>
            {InputEndIcon}
          </InputAdornment>
        ),
      }}
    />
  );
}

export default TextInput;
